







































import { Component, Prop, Watch } from "vue-property-decorator";
import EntityType from '@/models/Shared/EntityType';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import { CompanyDetailsModule } from '@/store/modules/companyDetails';
import { ContactDetailsModule } from '@/store/modules/contactDetails';
import { LocationDetailsModule } from '@/store/modules/locationDetails';
import { CampaignDetailsModule } from '@/store/modules/campaignDetails';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import NoteDto from "@/models/Notes/NoteDto";
import UpdateNoteRequest from "@/models/Notes/UpdateNoteRequest";


@Component({
  name: "NoteEdit",
})
export default class extends GiganautVueDialog {
  
  @Prop({required: true})
  entityType: EntityType;
  @Prop({required: true})
  note: NoteDto;
  entity: NoteDto = new NoteDto();
  dialog = false;

  @Watch("dialog")
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(this.note));
    }
  }


  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    switch (this.entityType){
        case EntityType.Booking:
            await BookingDetailsModule.editNote(this.entity);
            break;
        case EntityType.Job:
            await JobDetailsModule.editNote(this.entity);
            break;
        case EntityType.Worker:
            await WorkerDetailsModule.editNote(this.entity);
            break;
        case EntityType.Company:
            await CompanyDetailsModule.editNote(this.entity);
            break;
        case EntityType.Contact:
            await ContactDetailsModule.editNote(this.entity);
            break;
        case EntityType.Location:
            await LocationDetailsModule.editNote(this.entity);
            break;
        case EntityType.Campaign:
            await CampaignDetailsModule.editNote(this.entity);
            break;
    }
    this.dialog = false;
  }
}
